import { render } from "./AdditionalFilesModal.vue?vue&type=template&id=591ef0a6&scoped=true"
import script from "./AdditionalFilesModal.vue?vue&type=script&lang=js"
export * from "./AdditionalFilesModal.vue?vue&type=script&lang=js"

import "./AdditionalFilesModal.vue?vue&type=style&index=0&id=591ef0a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591ef0a6"],['__file',"src/components/AdditionalFilesModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "591ef0a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('591ef0a6', __exports__)) {
    api.reload('591ef0a6', __exports__)
  }
  
  module.hot.accept("./AdditionalFilesModal.vue?vue&type=template&id=591ef0a6&scoped=true", () => {
    api.rerender('591ef0a6', render)
  })

}


export default __exports__